import React from 'react';
import DashboardHeader from '../layouts/dashboard_header';
import SideMenu from '../layouts/dashboard_menu';
import Canvas from '../layouts/dahboard_canvas';
import DashboardFooter from '../layouts/dashboard_footer';
import ContractCenter from './ContractCenter';

const ContractCenterPage: React.FC = () => {
    return (
        <>
            <DashboardHeader />
            <SideMenu />
            <div className="main-content">
                <div className="page-content">
                    <ContractCenter />
                </div>
            </div>
            <Canvas />
            <DashboardFooter />
        </>
    );
};

export default ContractCenterPage;
